// The app's typeface, self-hosted (Latin, the four weights the screens use).
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-sans/latin-700.css';
import '@/ui/global.css';
import { startsPosApp } from '@/pos/where';

/**
 * Two apps from one page: the point of sale (src/pos: its own host, /<handle>/pos, the customer
 * display) or the back office (src/app). Each is its own bundle, so a till never downloads the back
 * office and the back office never downloads the till. Moving between them is a full page load.
 */
/**
 * Opened inside another site's frame (a platform admin that embeds apps, such as Shopify's): the
 * browser keeps eCommify's sign-in cookies out of it, so sign-in can never work there. Say so once,
 * with a button that opens eCommify in its own tab. Our own pages framing ours (same origin) are fine.
 */
function framedByAnotherSite(): boolean {
  if (window.self === window.top) return false;
  try {
    return window.top?.location.origin !== window.location.origin;
  } catch {
    return true;
  }
}

if (framedByAnotherSite()) {
  document.body.innerHTML = '';
  const box = document.createElement('main');
  box.style.cssText = 'font-family: "IBM Plex Sans", system-ui, sans-serif; max-width: 420px; margin: 15vh auto; padding: 24px; text-align: center; color: #111827';
  const title = document.createElement('h1');
  title.textContent = 'eCommify opens in its own tab';
  title.style.cssText = 'font-size: 18px; font-weight: 600; margin: 0 0 16px';
  const open = document.createElement('a');
  open.href = window.location.href;
  open.target = '_blank';
  open.rel = 'noopener';
  open.textContent = 'Open eCommify';
  open.style.cssText = 'display: inline-block; padding: 10px 18px; border-radius: 7px; background: #2f5bea; color: #fff; text-decoration: none; font-weight: 500';
  box.append(title, open);
  document.body.append(box);
} else if (startsPosApp(location)) void import('@/pos/boot').then((m) => m.boot());
else void import('@/app/boot').then((m) => m.boot());
